import {
	getNumber,
	getString,
	getArray,
} from "../../../../../utils/mappersUtils/object";

/**
 * For a single segment object, produce exactly 1 "segment row"
 * shape: { id, baseTranslations, translations: { [lang]: { item: { key: 'description', value: '...' } } } }
 */
export function checklistSegmentMapper(segmentObj) {
	const segId = getNumber(segmentObj, "id", 0);
	const segDesc = getString(segmentObj, "description", "");
	const segDetails = getArray(segmentObj, "segmentDetails");

	const translations = {};
	segDetails.forEach((sd) => {
		const lang = getString(sd, "language", "");
		if (!lang) return;
		translations[lang] = {
			item: {
				key: "description",
				value: getString(sd, "description", ""),
				maxLength: 64,
			},
		};
	});

	return [
		{
			id: segId,
			type: "SEGMENT",
			baseTranslations: {
				description: segDesc,
			},
			translations,
			fieldLimits: {
				description: 64,
			},
		},
	];
}
